export default ({ item }) => {
  return {
    item: {
      ...item,
      dataCmMetadata: `[{"_":{"$Ref":"content/${item.contentID}"}}]`
    }
  }
}
